/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiCreateSigningKeyRequestFromJSON(json) {
    return StreemApiCreateSigningKeyRequestFromJSONTyped(json, false);
}
export function StreemApiCreateSigningKeyRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'sharedSecret': !exists(json, 'shared_secret') ? undefined : json['shared_secret'],
        'expiresAt': !exists(json, 'expires_at') ? undefined : (new Date(json['expires_at'])),
        'label': !exists(json, 'label') ? undefined : json['label'],
    };
}
export function StreemApiCreateSigningKeyRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'shared_secret': value.sharedSecret,
        'expires_at': value.expiresAt === undefined ? undefined : (value.expiresAt.toISOString()),
        'label': value.label,
    };
}
//# sourceMappingURL=StreemApiCreateSigningKeyRequest.js.map